<template>
  <v-flex
    xs12
    class="page-title"
  >
    <v-icon
      v-if="navigateBackRoute"
      class="left pr-2"
      color="#757575"
      @click="navigateTo(navigateBackRoute)"
    >
      arrow_back
    </v-icon>
    <h1>
      {{ title }}
    </h1>
  </v-flex>
</template>

<script>
import RouterMixin from 'Support/mixins/router-mixin';

export default {
  name: 'PageTitle',
  mixins: [RouterMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
    navigateBackRoute: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="stylus" scoped>
.page-title
  width 100%
  .v-icon
    line-height 33px

h1
  font-style normal
  font-weight normal
  font-size 24px
  line-height 29px
  color #757575
</style>
